var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable babel/new-cap */
import { Vue, Component } from 'vue-property-decorator';
import { Action, State, Getter, Mutation } from 'vuex-class';
import logger from '@plat-components/utils2/_esm5/logger';
let RecommendPage = class RecommendPage extends Vue {
    get allFollwed() {
        return this.showMovieList.length && this.showMovieList.every(i => i.followed);
    }
    followPatch() {
        // const idList = this.showMovieList.filter(i => !i.followed).map(i => i.indexValue)
        const idList = this.showMovieList.map(i => i.indexValue);
        logger('click_followall', idList.join(','));
        this.FOLLOW_MOVIE_PATCH({ idList });
    }
    refreshFn() {
        logger('click_change');
        this.REFRESH_LIST();
    }
    handleMovieClick(item) {
        logger('click_card', {
            ssid: item.indexValue,
        });
    }
};
__decorate([
    State
], RecommendPage.prototype, "totalCount", void 0);
__decorate([
    Action
], RecommendPage.prototype, "FOLLOW_MOVIE_PATCH", void 0);
__decorate([
    Getter
], RecommendPage.prototype, "showMovieList", void 0);
__decorate([
    Mutation
], RecommendPage.prototype, "REFRESH_LIST", void 0);
RecommendPage = __decorate([
    Component
], RecommendPage);
export default RecommendPage;
